import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import MainPage from './Components/MainPage/MainPage.tsx';
import Summary from "./Components/Summary/Summary.tsx";
import Vulnerability from "./Components/Vulnerability/Vulnerability.tsx";
import "./App.css";
import InfoPage from "./Components/MainPage/InfoPage/InfoPage.tsx";

function SummaryRoute() {
  const { packageName } = useParams();
  return <Summary key={packageName} />;
}
function VulnerabilityRoute() {
  const { imageId } = useParams();
  return <Vulnerability key={imageId} />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/info" element={<InfoPage />} />
        <Route path="/" element={<MainPage />} />
        <Route path="/versions/:packageName/*" element={<SummaryRoute />} />
        <Route path="/vulnerabilities/:imageId" element={<VulnerabilityRoute />} />

      </Routes>
    </Router>
  );
}

export default App;
